import { KoForm, KoFormBuilder, KoNumber,  KoTextArea } from 'packages';
import React, { useCallback, useEffect } from 'react';
import styles from './holiday.module.scss';
const LeaveCrud = ({ form, handleFinish, initialValues }) => {
  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form.resetFields();
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);
    
  const handleSubmit = useCallback(values => {
    handleFinish(values);
  });


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'name', placeholder: 'Enter Title', label: 'Title', colSpan: 2, rules: [
          {
            required: true,
            message: `Please enter title.`
          }
        ]
      },
      {
        key: 'totalDays', placeholder: 'Enter total Days', label: 'Total Days', widget: KoNumber,  colSpan: 2, rules: [
          {
            required: true,
            message: `Please enter totalDays.`
          }
        ]
      },
      {
        key: 'description', widget: KoTextArea, label: 'Description', colSpan: 4, placeholder: 'Enter description'
      }
    ]

  };


  return (
    <div className={styles.delWrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
};

export default LeaveCrud;
